import React from 'react';
import classes from "./Home.module.css"
import professionsImg from "../../../assests/admin/professions.png"
import messagesImg from "../../../assests/admin/messages.png"
import studentbannerImg from "../../../assests/admin/studentbanner.png"
import teacherbannerImg from "../../../assests/admin/teacherbanner.png"
import filterPostsIconImg from "../../../assests/admin/filterPostsIcon.png"
import guidesIconImg from "../../../assests/admin/guidesIcon.png"
import trainingsImg from "../../../assests/admin/trainingIcon.png"
import * as PathRouter from '../../../models/PathRoute'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserActivityEnum } from '../../../models/UserActivityEnum';
import Permissions from '../../Permissions';


const Home = () => {
    const user = useSelector(state => state.auth.user);
    const texts = useSelector((state) => state.translate.texts);
    const tabs = [
        { name: `${texts.toEdit} ${texts.professionsTitle}`, img: professionsImg, link: PathRouter.DISCIPILINES, permission: UserActivityEnum.EditCourse },
        { name: `${texts.toAdd} ${texts.messages}`, img: messagesImg, link: PathRouter.MESSAGES, permission: UserActivityEnum.AddAlarms },
        { name: `${texts.toEdit} ${texts.teacherbanner}`, img: teacherbannerImg, link: PathRouter.TEACHER_BANNER, permission: UserActivityEnum.EditBanner },
        { name: `${texts.toEdit} ${texts.studentbanner}`, img: studentbannerImg, link: PathRouter.STUDENT_BANNER, permission: UserActivityEnum.EditBanner },
        { name: texts.filterPosts, img: filterPostsIconImg, link: PathRouter.POSTS, permission: UserActivityEnum.DeletePosts },
        { name: `${texts.toEdit} ${texts.trainings}`, img: trainingsImg, link: PathRouter.TRANINGS, permission: UserActivityEnum.AddTraining },
        { name: texts.monitoringSchools, img: guidesIconImg, link: PathRouter.GUIDE, permission: UserActivityEnum.LearningSupervision },
    ]

    return <div className={classes.AdminHome}>
        <div className={classes.Title}>{texts.adminHomeTitle}</div>
        <div className={classes.Tabs}>
            {tabs.map(t =>
                <Permissions key={t.name} activityType={t.permission}>
                    <Link to={t.link}>
                        <div className={classes.Tab} >
                            <div className={classes.Img} style={{ backgroundImage: `url(${t.img})` }}></div>
                            <div className={classes.Name}>{t.name}</div>
                        </div>
                    </Link>
                </Permissions>
            )}
        </div>
    </div>
}

export default Home;